/**
 * Signatur-Layouts für die Galerie im Signatur-Editor. Jedes Layout nutzt
 * ausschließlich die Platzhalter aus signatureTemplate.ts; der
 * Unternehmensname wird beim Einfügen aus den Stammdaten eingesetzt.
 */

export interface SignatureLayout {
  key: string
  title: string
  description: string
  /** Baut das HTML; `companyName` aus den Stammdaten des Unternehmens. */
  build: (companyName: string) => string
}

const NAME_LINE = '<strong>{{titel}} {{vorname}} {{nachname}}</strong>'
// Stellenbezeichnung steht zwischen Name und Unternehmen. Fehlt sie beim
// Mitarbeiter, entfernt renderSignatureHtml die Zeile rueckstandslos.
const ROLE_LINE = '{{stellenbezeichnung}}'

export const SIGNATURE_LAYOUTS: readonly SignatureLayout[] = [
  {
    key: 'classic',
    title: 'Klassisch',
    description: 'Gruß, Name, Unternehmen, Telefon und E-Mail auf mehreren Zeilen.',
    build: companyName =>
      'Mit freundlichen Grüßen<br><br>'
      + `${NAME_LINE}<br>`
      + `${ROLE_LINE}<br>`
      + `${companyName}<br><br>`
      + 'Tel: {{festnetz}} &nbsp;|&nbsp; Mobil: {{mobil}}<br>'
      + '{{email}}',
  },
  {
    key: 'compact',
    title: 'Kompakt einzeilig',
    description: 'Alle Kontaktdaten in einer Zeile – für kurze Antworten.',
    build: companyName =>
      'Mit freundlichen Grüßen<br><br>'
      + `${NAME_LINE} · ${ROLE_LINE} · ${companyName} · Tel: {{festnetz}} · Mobil: {{mobil}} · {{email}}`,
  },
  {
    key: 'location',
    title: 'Mit Standortblock',
    description: 'Ergänzt Standortname, Anschrift und Standort-Telefon des gewählten Standorts.',
    build: companyName =>
      'Mit freundlichen Grüßen<br><br>'
      + `${NAME_LINE}<br>`
      + `${ROLE_LINE}<br>`
      + `${companyName}<br><br>`
      + '{{standort}}<br>'
      + '{{standort_adresse}}<br>'
      + 'Tel: {{standort_telefon}} &nbsp;|&nbsp; Mobil: {{mobil}}<br>'
      + '{{email}}',
  },
  {
    key: 'website',
    title: 'Mit Webseite & Datenschutzhinweis',
    description: 'Klassisches Layout plus Webseite und kurzem Vertraulichkeitshinweis.',
    build: companyName =>
      'Mit freundlichen Grüßen<br><br>'
      + `${NAME_LINE}<br>`
      + `${ROLE_LINE}<br>`
      + `${companyName}<br><br>`
      + 'Tel: {{festnetz}} &nbsp;|&nbsp; Mobil: {{mobil}}<br>'
      + '{{email}}<br>'
      + '{{webseite}}<br><br>'
      + '<span style="font-size: 0.85em; color: #6b7280;">Diese E-Mail kann vertrauliche Informationen enthalten. '
      + 'Sollten Sie nicht der richtige Adressat sein, informieren Sie bitte den Absender und löschen Sie diese Nachricht.</span>',
  },
]
